(function() { window.GUID_08b211d4_79c9_4980_81df_0dd13a8ca85b = { getGuid: function() { return "08b211d4-79c9-4980-81df-0dd13a8ca85b"; } }; })();
var GoogleAds;
(function (GoogleAds) {
    const pendingBindAttribute = "data-cs-googleads-bound";
    const retryScheduledAttribute = "data-cs-googleads-retry-scheduled";
    const retryCountAttribute = "data-cs-googleads-retry-count";
    const observedAttribute = "data-cs-googleads-observed";
    const minimumFluidAdWidth = 250;
    const retryDelayMs = 250;
    const maxAutomaticBindRetries = 2;
    const viewportMarginPixels = 300;
    let intersectionObserver = null;
    function getAdsInScope(container) {
        const $scope = container ? $(container) : $(document);
        return $scope.filter(".adsbygoogle").add($scope.find(".adsbygoogle"));
    }
    function isAlreadyBound(adElement, $ad) {
        return !!($ad.attr("data-adsbygoogle-status") || $ad.attr(pendingBindAttribute) || adElement.childElementCount > 0);
    }
    function isRenderable(adElement, $ad) {
        if (!adElement.isConnected) {
            return false;
        }
        const style = window.getComputedStyle(adElement);
        if (style.display === "none" || style.visibility === "hidden") {
            return false;
        }
        const width = Math.ceil(adElement.getBoundingClientRect().width);
        if (width <= 0) {
            return false;
        }
        return ($ad.attr("data-ad-format") || "").toLowerCase() !== "fluid" || width >= minimumFluidAdWidth;
    }
    function isNearViewport(adElement) {
        const rect = adElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        return rect.bottom >= -viewportMarginPixels && rect.top <= viewportHeight + viewportMarginPixels;
    }
    function bindAd(adsByGoogle, adElement, $ad) {
        $ad.attr(pendingBindAttribute, "true");
        $ad.removeAttr(retryCountAttribute);
        $ad.removeAttr(retryScheduledAttribute);
        $ad.removeAttr(observedAttribute);
        try {
            adsByGoogle.push({});
        }
        catch (e) {
            $ad.removeAttr(pendingBindAttribute);
            if (shouldStopBinding(e)) {
                return false;
            }
        }
        return true;
    }
    function onAdIntersection(entries) {
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
                continue;
            }
            const adElement = entry.target;
            const $ad = $(adElement);
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.unobserve(adElement);
            $ad.removeAttr(observedAttribute);
            BindAds(true, adElement);
        }
    }
    function getIntersectionObserver() {
        if (typeof window.IntersectionObserver === "undefined") {
            return null;
        }
        if (intersectionObserver == null) {
            intersectionObserver = new window.IntersectionObserver(onAdIntersection, {
                root: null,
                rootMargin: `${viewportMarginPixels}px 0px ${viewportMarginPixels}px 0px`,
                threshold: 0.01,
            });
        }
        return intersectionObserver;
    }
    function deferUntilVisible(adElement, $ad) {
        const observer = getIntersectionObserver();
        if (observer == null || isNearViewport(adElement)) {
            return false;
        }
        if (!$ad.attr(observedAttribute)) {
            $ad.attr(observedAttribute, "true");
            observer.observe(adElement);
        }
        return true;
    }
    function scheduleRetry(adElement, $ad) {
        if ($ad.attr(retryScheduledAttribute) || isAlreadyBound(adElement, $ad)) {
            return;
        }
        const currentRetryCount = parseInt($ad.attr(retryCountAttribute) || "0", 10);
        if (isNaN(currentRetryCount) || currentRetryCount >= maxAutomaticBindRetries) {
            return;
        }
        $ad.attr(retryScheduledAttribute, "true");
        window.setTimeout(() => {
            $ad.removeAttr(retryScheduledAttribute);
            if (!adElement.isConnected) {
                return;
            }
            $ad.attr(retryCountAttribute, `${currentRetryCount + 1}`);
            BindAds(true, adElement);
        }, retryDelayMs);
    }
    function shouldStopBinding(error) {
        const errorMessage = error instanceof Error ? error.message : `${error !== null && error !== void 0 ? error : ""}`;
        return errorMessage.indexOf("All 'ins' elements in the DOM with class=adsbygoogle already have ads in them.") >= 0;
    }
    function BindAds(enabled, container) {
        if (enabled) {
            $(function () {
                try {
                    if (CS.GlobalConst.UseGoogleAdsense) {
                        const adsByGoogle = (window.adsbygoogle =
                            window.adsbygoogle || []);
                        adsByGoogle.requestNonPersonalizedAds = CS.CookieConsent.CanUseGoogleAdsCookies() ? 0 : 1;
                        const $ads = getAdsInScope(container);
                        $ads.each(function () {
                            const adElement = this;
                            const $ad = $(adElement);
                            if (isAlreadyBound(adElement, $ad)) {
                                return;
                            }
                            if (!isRenderable(adElement, $ad)) {
                                scheduleRetry(adElement, $ad);
                                return;
                            }
                            if (deferUntilVisible(adElement, $ad)) {
                                return;
                            }
                            if (!bindAd(adsByGoogle, adElement, $ad)) {
                                return false;
                            }
                        });
                    }
                }
                catch (e) {
                }
            });
        }
    }
    GoogleAds.BindAds = BindAds;
})(GoogleAds || (GoogleAds = {}));

//# sourceMappingURL=googleads.js.map
